import { z } from "zod/mini"

import { RichTextModelNodeType, type RichTextModel } from "./richText"

const TableConfigSchema = z.object({
	label: z.nullish(z.string()),
})

export const TableModelSchema = z.object({
	type: z.literal("Table"),
	config: z.optional(TableConfigSchema),
})

export type TableModel = z.infer<typeof TableModelSchema>

// TableCell configuration constant (used for cell rich text configuration)
export const TableCellModelNodeTypes = [
	RichTextModelNodeType.paragraph,
	RichTextModelNodeType.strong,
	RichTextModelNodeType.em,
	RichTextModelNodeType.hyperlink,
]

export const TableCellModel: RichTextModel = {
	type: "StructuredText" as const,
	config: {
		multi: TableCellModelNodeTypes.join(","),
	},
}
